import React from 'react';
import ReactDOM from 'react-dom';
import FormApp from './routes/formulario-externo-spc/pages/FormApp.tsx';
import './common/styles/index.scss';
import { Provider } from 'react-redux';
import { store } from './routes/formulario-externo-spc/store.ts';
//import { createRoot } from 'react-dom/client';

const App = ({ route, llave_recaptcha }) => {
	return (
		<Provider store={store}>
			<FormApp llave_recaptcha={llave_recaptcha}></FormApp>
		</Provider>
	);
};

class WebComponent extends HTMLElement {
	// connectedCallback() {
	// 	const container = document.getElementById('formulario-microfront');
	// 	const root = createRoot(container);
	// 	root.render(<App route={this.getAttribute("route")} />);
	// }
	connectedCallback() {
		ReactDOM.render(
			<App route={this.getAttribute("route")} llave_recaptcha={this.getAttribute("llaveRecapcha")} />,
			this
		);
	}
}

const ELEMENT_ID = 'formulario-microfront';

if (!customElements.get(ELEMENT_ID)) {
	customElements.define(ELEMENT_ID, WebComponent);
}

